'use strict';

function dateStringToDate(date) {
  var split = date.split('/');
  var year = +split[2]; //make integer
  if (year < 100) {
    year += 2000;
  }
  var month = +split[1] - 1; //make integer and zero indexed
  var day = +split[0]; //make integer
  return new Date(year, month, day);
}

function dateToDateString(value) {
  var result = new Date(value);
  var dd = result.getDate();
  var mm = result.getMonth() + 1; //January is 0

  var yyyy = result.getFullYear();

  var today = dd + '/' + mm + '/' + yyyy;
  return today;
}

export default class {
  /*@ngInject*/
  constructor($http, JSONToCSVConvertor, StringToCSV) {
    this.$http = $http;
    this.JSONToCSVConvertor = JSONToCSVConvertor;
    this.StringToCSV = StringToCSV;
    this.filteredTimesheets = [];
    this.loading = true;
    this.loadsRequired = 2;
  }

  $onInit() {
    this.loadData();
  }

  lowerLoad() {
    this.loadsRequired -= 1;

    if (this.loadsRequired === 0) {
      this.processData();
      this.loading = false;
    }
  }

  loadData() {
    this.$http.get('/api/students').then(res => {
      this.students = res.data;
      this.lowerLoad();
    });

    this.$http.get('/api/timesheets').then(res => {
      this.timesheets = res.data;
      this.lowerLoad();
    });
  }

  export(){
    const today = new Date();
    const day = String(today.getDate());
		const month = String(today.getMonth() + 1);
		const year = String(today.getFullYear());
		const date = day + '-' + month + '-' + year;
    const filename = 'Tutor-Overview-' + date;
    
    this.StringToCSV(this.exportText, filename);
  }

  processData() {
    let timesheets = this.timesheets.map(timesheet => {
      timesheet.date = dateStringToDate(timesheet.weekEnding);

      return timesheet;
    }).sort((a, b) => {
      const aTime = a.date.getTime();
      const bTime = b.date.getTime();

      if (aTime < bTime) {
        return -1;
      }

      if (aTime < bTime) {
        return -1;
      }

      return 0;

    })
    //First, attach timesheets to students
    let students = this.students.map(student => {
      student.timesheets = timesheets.filter(timesheet => timesheet.studentID === student.studentID)

      return student;
    })

    //Remove students with no timesheets
    students = students.filter(
      student => student.timesheets && student.timesheets.length !== 0
    )

    //Calc time for each year from there
    const years = [2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018]
    students = students.map(student => {
      years.forEach(year => {
        const targ = student.timesheets.filter(
          timesheet => timesheet.date.getFullYear() === year
        )

        let hourTotal, first, last;

        if(targ.length){
          const hours = targ.map(timesheet => timesheet.hours)
          hourTotal = hours.reduce((a, b) => a + b);

          first = targ[0].weekEnding;
          last = targ[targ.length - 1].weekEnding;
        }

        student[String(year)] = {
          hours: hourTotal,
          first,
          last,
        };
      })

      return student;
    })

    const header = [
      'Client ID', 
      'State', 
      'Location', 
      'First Session in 2011', 
      'Last Session in 2011',
      '2011 Hours',
      'First Session in 2012', 
      'Last Session in 2012',
      '2012 Hours',
      'First Session in 2013', 
      'Last Session in 2013',
      '2013 Hours',
      'First Session in 2014', 
      'Last Session in 2014',
      '2014 Hours',
      'First Session in 2015', 
      'Last Session in 2015',
      '2015 Hours',
      'First Session in 2016', 
      'Last Session in 2016',
      '2016 Hours',
      'First Session in 2017', 
      'Last Session in 2017',
      '2017 Hours',
      'First Session in 2018', 
      'Last Session in 2018',
      '2018 Hours',
    ].map(cell => `"${cell}"`).join(',');

    const dict = {
      C: 'Cannon Hill',
      H: 'Home',
      O: 'Online',
      P: 'Paddington'
    }
    const body = students.map(student => {
      let line = [];
      line.push(student.crmID);
      line.push(student.state);
      line.push(student.tuteLocation ? dict[student.tuteLocation] : 'Unset')
      
      years.forEach(year => {
        line.push(student[String(year)].first || '')
        line.push(student[String(year)].last || '')
        line.push(student[String(year)].hours || '')
      })

      return line.map(cell => cell ? `"${cell}"` : '').join(',');
    }).join('\n');

    this.exportText = header+ '\n' + body;
  }
}



// WEBPACK FOOTER //
// ./client/app/reports/student-overview/student-overview.controller.js